import { Objects, UIImages } from '../utils/Consts';
import BaseOverlay from './BaseOverlay';
import Utils from '../utils/Utils';

class NewspaperOverlay extends BaseOverlay {
	constructor(scene, uiHandler, audioManager) {
		super(scene, uiHandler, audioManager);
		this.newspaper = this.uiHandler.createImage(Utils.centerX(), Utils.centerY(), UIImages.newspaperBasic);
		this.assetContainer.add(this.newspaper);
		this.hide(false);
	}

	hide(hiddenByPlayer = true) {
		super.hide(hiddenByPlayer);
		this.newspaper.setVisible(this.visible);
		this.newspaper.disableInteractive();

		if (hiddenByPlayer && this.scene.gameState.newspaperFound === false) {
			this.scene.gameState.newspaperFound = true;
			this.scene.objectsManager.appearAnimation(Objects.newspaperLocated);
		}
	}

	show() {
		super.show();
		this.newspaper.setVisible(this.visible);
		this.newspaper.setInteractive();
	}
}

export default NewspaperOverlay;
